import { type FC, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Tournament registration page - redirects to event registration wizard
 * This maintains backward compatibility with old tournament registration URLs
 */
export const TournamentRegistrationPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to event registration wizard with pre-selected tournament
    if (id) {
      navigate('/event-registration', {
        state: { preselectedTournamentId: id },
        replace: true
      });
    } else {
      navigate('/tournaments', { replace: true });
    }
  }, [id, navigate]);

  // Show loading state while redirecting
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
        <p className="mt-4 text-muted-foreground">Redirecting to registration...</p>
      </div>
    </div>
  );
};
